import Axios from '../plugins/axios'

export const fetchEntrances = function (fields) {
    if (fields) {
        return Axios.get('entrances?fields=' + fields.join(';'))
    }

    return Axios.get('entrances?lang=bg')
}

export const removeEntrance = function (id) {
    return Axios.delete('entrances/' + id)
}

export const createEntrance = function (entrance) {
    return Axios.post('entrances/', entrance)
}

export const fetchEntrance = function (id) {
    return Axios.get(`entrances/${id}?lang=bg`)
}

export const updateEntrance = function (id, entrance) {
    return Axios.put(`entrances/${id}`, entrance)
}